import { PlanType } from "./types";

const url = "/api/v1/promo_codes";

export interface PromoCodesShowParams {
  plan: PlanType;
  promoCode: string;
}

export const promoCodesShowQuery = (params: PromoCodesShowParams) => ({
  url: `${url}/${params.promoCode}?plan=${params.plan}`,
  method: "GET",
});

export interface Coupon {
  id: string;
  amount_off: number | null;
  duration_in_months: number;
  percent_off: number | null;
}

interface ValidResponse {
  id: string;
  coupon: Coupon;
  key: "valid";
  message: string;
}

interface OtherResponse {
  key: "invalid" | "not_found" | "missing_metadata";
  message: string;
}

export type PromoCodesShowResponse = ValidResponse | OtherResponse;
